import React, { useEffect, useState } from 'react';
import './index.css';
import backgroundImage from './Pictures/hero.png'; // Import the image

function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 950);
  const [isHalfDesktop, setIsHalfDesktop] = useState(window.innerWidth >= 950 && window.innerWidth < 1050);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 950);
      setIsHalfDesktop(window.innerWidth >= 950 && window.innerWidth < 1050);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://book.mylimobiz.com/v4/Scripts/iframeResizer/iframeResizer.min.js';
    script.async = true;
    script.onload = () => {
      window.iFrameResize({ log: false }, '#booking-iframe');
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <main id="top" className="relative">
      <div className="content relative z-10 flex flex-col items-end">
        {!isMobile && (
          <header className="luxury-header pt-36 pb-16 px-4 md:px-24 hidden md:block">
            {!isHalfDesktop && <h2>Luxury Ground Transportation</h2>}
            {isHalfDesktop && <div className="luxury-header-text">Luxury Ground Transportation</div>}
          </header>
        )}
        <div className="background-container pt-24 hidden md:block">
          <img src={backgroundImage} alt="Luxury Car Services" loading="lazy" className="w-full h-auto" />
        </div>
        <section className="booking-container hidden md:block absolute top-0 right-0 mt-36 mr-24 w-[400px] min-h-[500px] bg-white bg-opacity-90 backdrop-blur-md shadow-lg z-20">
          <iframe
            src="https://book.mylimobiz.com/v4/longislandcc"
            title="Booking"
            className="booking-iframe w-full h-full rounded-lg border-none shadow-lg transition-transform duration-300 ease-in-out hover:translate-y-[-2px]"
            style={{ minHeight: '550px' }} // Changed from 500px
          ></iframe>
        </section>
      </div>
      <div className="bg-white md:hidden flex flex-col items-center mt-12 justify-center">
        <div className="w-full h-1/3 relative">
          <img src={backgroundImage} alt="Luxury Car Services" loading="lazy" className="w-full h-full object-cover" />
        </div>
        <section className="w-full bg-white bg-opacity-90 backdrop-blur-md shadow-lg">
          <iframe
            id="booking-iframe"
            src="https://book.mylimobiz.com/v4/longislandcc"
            title="Booking"
            className="booking-iframe w-full border-none shadow-lg transition-transform duration-300 ease-in-out hover:translate-y-[-2px]"
            style={{ minWidth: '100%', overflow: 'hidden', minHeight: '550px' }} // Replace fixed height
          ></iframe>
        </section>
      </div>
    </main>
  );
}

export default Home;
